// extracted by mini-css-extract-plugin
module.exports = {"Container":"Selector_Container__1TNu3","Selector":"Selector_Selector__3hDYh","Label":"Selector_Label__2eNSV"};